import { render, staticRenderFns } from "./warnings.vue?vue&type=template&id=6c098306&"
import script from "./warnings.vue?vue&type=script&lang=js&"
export * from "./warnings.vue?vue&type=script&lang=js&"
import style0 from "./warnings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports